'use strict';

class SearchError extends React.Component {
    render() {
        const {tag, onRetry} = this.props;

        return <div className="error-message">
            <i className="icon-error"/>
            {tag === 'ServerError' && <React.Fragment>
                <div>
                    <span>{tMsg('Возникла ошибка при поиске')}</span>
                </div>
                <div>
                    <a role="button" onClick={onRetry} style={{cursor: 'pointer'}}>{tMsg('Попробуйте ещё раз')}</a>
                </div>
            </React.Fragment>}
        </div>
    }
}
